





































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencyModule } from '@/store/modules/agency';
import { AppModule } from '@/store/modules/app';
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import NavigationMenuItem from '@/models/Shared/NavigationMenuItem';
import IconConstants from '@/lib/iconConstants';
import PageNames from '@/router/PageNames';

@Component({
	name: 'AgencySettings',
  	components: { Alert }
})
export default class extends GiganautVue {

	public agencyMenuItems: NavigationMenuItem[] = [];
	public usersMenuItems: NavigationMenuItem[] = [];
	public communicationMenuItems: NavigationMenuItem[] = [];
	public categoryMenuItems: NavigationMenuItem[] = [];
	public workTypeMenuItems: NavigationMenuItem[] = [];
	public integrationMenuItems: NavigationMenuItem[] = [];

	beforeMount() {
		// Agency
		if (this.canView(this.Permissions.SettingsAgencyProfile)) this.agencyMenuItems.push(new NavigationMenuItem(PageNames.AgencyProfileSettings, "Agency Profile", IconConstants.Agency));
		if (this.canView(this.Permissions.SettingsBranches)) this.agencyMenuItems.push(new NavigationMenuItem(PageNames.AgencyBranchSettings, "Branches & Desks", IconConstants.Branch));
		if (this.canView(this.Permissions.SettingsRateCards)) this.agencyMenuItems.push(new NavigationMenuItem(PageNames.AgencyRateCardSettings, "Rate Cards", IconConstants.RateCard));
		if (this.canView(this.Permissions.SettingsUniforms)) this.agencyMenuItems.push(new NavigationMenuItem(PageNames.AgencyUniformSettings, "Uniforms", IconConstants.Uniform));
		if (this.canView(this.Permissions.SettingsReportingPeriods)) this.agencyMenuItems.push(new NavigationMenuItem(PageNames.AgencyReportingPeriodSettings, "Reporting Periods", IconConstants.ReportingPeriod));
		if (this.canView(this.Permissions.SettingsKpis)) this.agencyMenuItems.push(new NavigationMenuItem(PageNames.AgencyKpiSettings, "KPIs", IconConstants.Kpi));

		// Users & Permissions
		if (this.canView(this.Permissions.SettingsUsers)) this.usersMenuItems.push(new NavigationMenuItem(PageNames.AgencyUserSettings, "Users", IconConstants.User));
		if (this.canView(this.Permissions.SettingsGroups)) this.usersMenuItems.push(new NavigationMenuItem(PageNames.AgencyGroupSettings, "Groups", IconConstants.Group));
		if (this.canView(this.Permissions.SettingsRoles)) this.usersMenuItems.push(new NavigationMenuItem(PageNames.AgencyRoleSettings, "Roles", IconConstants.AgencyRole));

		// Communication
		if (this.canView(this.Permissions.SettingsEmailTemplates)) this.communicationMenuItems.push(new NavigationMenuItem(PageNames.AgencyEmailTemplateSettings, "Email Templates", IconConstants.Email));
		if (this.canView(this.Permissions.SettingsConversationTopics)) this.communicationMenuItems.push(new NavigationMenuItem(PageNames.AgencyConversationTopicSettings, "Conversation Topics", IconConstants.ConversationTopic));
		if (this.canView(this.Permissions.SettingsBusinessHours)) this.communicationMenuItems.push(new NavigationMenuItem(PageNames.AgencyBusinessHoursSettings, "Business Hours", IconConstants.BusinessHours));

		// Categories
		if (this.canView(this.Permissions.SettingsNoteCategories)) this.categoryMenuItems.push(new NavigationMenuItem(PageNames.AgencyNoteCategorySettings, "Note Categories", IconConstants.NoteCategory));
		if (this.canView(this.Permissions.SettingsActivityCategories)) this.categoryMenuItems.push(new NavigationMenuItem(PageNames.AgencyActivityCategorySettings, "Activity Categories", "mdi-tag-multiple"));
		if (this.canView(this.Permissions.SettingsOpportunitySources)) this.categoryMenuItems.push(new NavigationMenuItem(PageNames.AgencyOpportunitySourceSettings, "Opportunity Sources", IconConstants.OpportunitySource));
		if (this.canView(this.Permissions.SettingsOpportunityLostReasons)) this.categoryMenuItems.push(new NavigationMenuItem(PageNames.AgencyOpportunityLostReasonSettings, "Opportunity Lost Reasons", IconConstants.OpportunityLostReason));

		// Work Types
		if (this.canView(this.Permissions.SettingsIndustries)) this.workTypeMenuItems.push(new NavigationMenuItem(PageNames.AgencyIndustrySettings, "Industries", IconConstants.Industry));
		if (this.canView(this.Permissions.SettingsLocationTypes)) this.workTypeMenuItems.push(new NavigationMenuItem(PageNames.AgencyLocationTypeSettings, AppModule.currentAgencyContext.labels.location + " Types", IconConstants.Location));
		if (this.canView(this.Permissions.SettingsSkills)) this.workTypeMenuItems.push(new NavigationMenuItem(PageNames.AgencySkillSettings, "Skills", IconConstants.Skill));
		if (this.canView(this.Permissions.SettingsQualifications)) this.workTypeMenuItems.push(new NavigationMenuItem(PageNames.AgencyQualificationSettings, "Qualifications", IconConstants.Qualification));
		if (this.canView(this.Permissions.SettingsPositions)) this.workTypeMenuItems.push(new NavigationMenuItem(PageNames.AgencyPositionSettings, "Positions", IconConstants.Position));

		// Integrations
		if (this.canView(this.Permissions.SettingsIntegrations)) this.integrationMenuItems.push(new NavigationMenuItem(PageNames.AgencyIntegrationSettings, "Integrations", IconConstants.Integration));
		if (this.canView(this.Permissions.SettingsMobileApp)) this.integrationMenuItems.push(new NavigationMenuItem(PageNames.AgencyAppSettings, "Mobile App", IconConstants.App));
  	}

	navigate(pageName: string) {
		    this.$router.push({ name: pageName });
	}
}
